import { render, staticRenderFns } from "./LugarInformacionTecnica.vue?vue&type=template&id=205abf43&scoped=true"
import script from "./LugarInformacionTecnica.vue?vue&type=script&lang=js"
export * from "./LugarInformacionTecnica.vue?vue&type=script&lang=js"
import style0 from "./LugarInformacionTecnica.vue?vue&type=style&index=0&id=205abf43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205abf43",
  null
  
)

export default component.exports